import { useEffect, useState } from 'react'
import { API, Auth } from 'aws-amplify'
import Modal from '../../../components/Modal'
import SpinnerLoading from '../../../components/SpinnerLoading'
const ReSyncOrder = ({ show, orderId, onHide, onSyncCompleted }) => {
  const [error, setError] = useState(null)

  useEffect(() => {
    if (show) {
      const syncOrderFromSAP = async () => {
        try {
          setError(null)
          const session = await Auth.currentSession()
          const idToken = session.idToken.jwtToken
          const getInit = {
            headers: { "Content-Type": "application/json", "Authorization": idToken }
          }
          const apiName = process.env.REACT_APP_REST_API_NAME
          const result = await API.get(apiName, `/sap/order/${orderId}`, getInit)
          onSyncCompleted(result.operations)
        } catch(err) {
          console.log(err)
          setError(err.response && err.response.data ? err.response.data.message : `SAP API do not available for ${process.env.REACT_APP_ENV}`)
        }
      }
      syncOrderFromSAP()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  return <Modal
    show={show}
    onHide={onHide}
    cancelText='ยกเลิก'
    title='เชื่อมต่อข้อมูลล่าสุดกับ SAP'
  >
    {error ? error : <div className="flex flex-col items-center justify-center">
      <SpinnerLoading/>
      <h6 className='mt-3'>กำลังเชื่อมข้อมูลล่าสุดของ Order {orderId} จาก SAP</h6>
    </div>}
  </Modal>
}

export default ReSyncOrder